module.exports = __webpack_public_path__ + "static/media/Group76-1600.1756a843.webp";